export const removeTimeZone = (dateString: string) => {
	return dateString.split('T')[0];
};
